/* Rodapé NIGMA — mensagens do formulário Brevo + carregamento sob demanda do main.js da Brevo.
   Movido do inline de sections/footer.liquid em 23/09/2026 (carregado com defer). */
window.REQUIRED_CODE_ERROR_MESSAGE = 'Escolha um código de país';
window.LOCALE = 'pt';
window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = 'Revise o e-mail informado e tente novamente.';
window.REQUIRED_ERROR_MESSAGE = 'Preencha este campo para continuar.';
window.GENERIC_INVALID_MESSAGE = 'Revise o e-mail informado e tente novamente.';
window.INVALID_NUMBER = 'Revise o e-mail informado e tente novamente.';
window.INVALID_DATE = 'Insira uma data válida';
window.REQUIRED_MULTISELECT_MESSAGE = 'Selecione pelo menos 1 opção';
window.translation = { common: { selectedList: '{quantity} lista selecionada', selectedLists: '{quantity} listas selecionadas', selectedOption: '{quantity} selecionado', selectedOptions: '{quantity} selecionados' } };
window.AUTOHIDE = false;
(function () {
  var form = document.getElementById('sib-form');
  var container = document.getElementById('sib-form-container');
  if (!form || !container) return;

  var scriptLoaded = false;
  var scriptLoading = false;
  var callbacks = [];

  function loadBrevoForm(callback) {
    if (typeof callback === 'function') callbacks.push(callback);
    if (scriptLoaded) {
      while (callbacks.length) callbacks.shift()(true);
      return;
    }
    if (scriptLoading) return;
    scriptLoading = true;

    var script = document.createElement('script');
    script.src = 'https://sibforms.com/forms/end-form/build/main.js';
    script.async = true;
    script.onload = function () {
      scriptLoaded = true;
      scriptLoading = false;
      while (callbacks.length) callbacks.shift()(true);
    };
    script.onerror = function () {
      scriptLoading = false;
      var failedCallbacks = callbacks.slice();
      callbacks = [];
      while (failedCallbacks.length) failedCallbacks.shift()(false);
    };
    document.head.appendChild(script);
  }

  /* 27/09/2026 · auditoria de velocidade: o script da Brevo (125 KB) só carrega quando o cliente toca,
     passa o mouse ou foca no formulário. Antes carregava quando o rodapé chegava a 800 px da tela,
     o que em páginas curtas acontecia já na abertura. O envio segue garantido pelo listener de submit abaixo. */
  container.addEventListener('focusin', loadBrevoForm, { once: true });
  container.addEventListener('pointerenter', loadBrevoForm, { once: true, passive: true });
  container.addEventListener('touchstart', loadBrevoForm, { once: true, passive: true });
  form.addEventListener('submit', function ensureBrevoBeforeSubmit(event) {
    if (scriptLoaded) return;
    event.preventDefault();
    loadBrevoForm(function (loaded) {
      if (loaded) {
        form.requestSubmit();
        return;
      }

      // Se a CDN da Brevo falhar, preserva o cadastro pelo POST nativo.
      HTMLFormElement.prototype.submit.call(form);
    });
  }, true);
})();
